module.exports = __webpack_public_path__ + "static/media/sakred-filter.e9c08d97.jpeg";